import { render, staticRenderFns } from "./seeOriginalPrice.vue?vue&type=template&id=54c5b90f&scoped=true&"
import script from "./seeOriginalPrice.vue?vue&type=script&lang=js&"
export * from "./seeOriginalPrice.vue?vue&type=script&lang=js&"
import style0 from "./seeOriginalPrice.vue?vue&type=style&index=0&id=54c5b90f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c5b90f",
  null
  
)

export default component.exports